export default __webpack_public_path__ + "static/media/red_icon_with_notes.fc51861b.png";